module.exports = __webpack_public_path__ + "static/media/SE.0ff71789.svg";